import { EXERCISES } from '@/clients'
import { rmotrErrorHandler } from '@/helpers'

/**
 * Get an Exercise
 * @param exerciseId as uuid
 */
const fetchExerciseById = async exerciseId => {
  const route = `exercises/${exerciseId}`
  return EXERCISES.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Get the tests of an exercise
 * @param exerciseId as uuid
 */
const fetchExerciseTestsByExerciseId = async exerciseId => {
  const route = `exercises/${exerciseId}/tests`
  return EXERCISES.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Get the solutions of an exercise
 * @param exerciseId as uuid
 */
const fetchExerciseSolutionsByExerciseId = async exerciseId => {
  const route = `exercises/${exerciseId}/solutions`
  return EXERCISES.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

const runCode = async params => {
  const { exerciseId, code, flavor } = params
  const route = `exercises/${exerciseId}/executions`
  return EXERCISES.post(route, {
    submitted_code: code,
    flavor,
  })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

const runTest = async params => {
  const { exerciseId, testId, code, flavor } = params
  const route = `exercises/${exerciseId}/tests/${testId}/executions`
  return EXERCISES.post(route, {
    submitted_code: code,
    flavor,
  })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

const runAttempt = async params => {
  const { exerciseId, code, flavor } = params
  const route = `exercises/${exerciseId}/attempts`
  return EXERCISES.post(route, {
    submitted_code: code,
    flavor,
  })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

const fetchExerciseAttempts = async exerciseId => {
  const route = `exercises/${exerciseId}/attempts`
  return EXERCISES.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

export {
  fetchExerciseById,
  fetchExerciseTestsByExerciseId,
  fetchExerciseSolutionsByExerciseId,
  runCode,
  runTest,
  runAttempt,
  fetchExerciseAttempts,
}
